<template>
  <div :style="wrapStyle">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-public-reward-box v-bind="$props" ref="rewardBox"></c-public-reward-box>
  </div>
</template>
<script>
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CPublicRewardBox from '@tencent/ceiba-act-public-reward-box';
export default {
  name: 'CCommercialRepeatedlyLottery',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
    [CPublicRewardBox.name]: CPublicRewardBox,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'commercial-repeatedly-lottery-',
      packageName: '',
      isShow: false,
      showImage: false,
      isShowDynamicEffectDialog: false, // 弹框展示与否
      packageImgArr: [], // 活动奖励图片列表
      surplusLotteryTimes: 200, // 剩余抽奖次数
      onceOrtimesFlag: true, // 一次或多次抽奖数量控制变量
      count: 0,
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.dialogConfig, {
        header: '温馨提示',
        fotter: false,
      });
    },
    wrapStyle() {
      return {
        top: this.styles.base.top,
        left: this.styles.base.left,
        width: this.styles.base.width,
        height: this.styles.base.height,
      };
    },
    computedStyle() {
      if (this.enable) {
        return {
          backgroundImage: `url(${encodeURI(this.configurationData.rewardImg)})`,
        };
      }
      return {
        backgroundImage: `url(${encodeURI(this.configurationData.rewardedImg)})`,
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowID];
      if (!packageStatus) return true;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.surplusLotteryTimes = packageStatus.remain;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    initialize() {
      this.$refs.button.setClickHandler(this.doReward, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.configurationData.forceRole,
      });
    },
    closeBtnClick() {
      this.isShow = false;
    },
    async doReward() {
      this.packageName = ''; // 置空
      let lotteryNums = 0;
      if (this.configurationData?.queryLotteryNumFlowId) {
        const lotteryNumResponse = await this.flowRequest({
          flowId: this.configurationData.queryLotteryNumFlowId,
        });
        lotteryNums = lotteryNumResponse?.data?.useNum || lotteryNumResponse?.data?.remain
          || lotteryNumResponse?.data?.value;
      }
      const num = parseInt(this.configurationData.lotteryNum, 10);
      let response = await this.flowRequest({
        flowId: this.configurationData.flowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            pNum: num,
          }),
        },
      });
      response = this.$refs.rewardBox.handlerLotteryModeResponse(response);
      console.log('【CCommercialRepeatedlyLottery】doReward response = ', response);
      await this.refreshQua(); // 刷新礼包
      this.handleClickEvent();
      if (response.ret !== 0) {
        this.alert(response.data.msg || response.msg);
      } else if (response.ret === 0) {
        if (response?.data?.ret === 0) {
          await this.showNewPop(response, lotteryNums);
        } else {
          this.alert(response.data.msg || response.msg);
        }
      }
    },
    /**
     * 调用欧皇新弹窗
     * @param responseData
     * @returns {Promise<void>}
     */
    async showNewPop(responseData, nums) {
      const iconArr = {
        packageConfig: {},
        displayConfig: {},
      };
      let headerText = '恭喜获得';
      let ripsText = '';
      if (parseInt(responseData.data.package_id, 10)
        === parseInt(this.configurationData?.displayConfig?.defaultGiftId, 10)) {
        headerText = '温馨提示';
        ripsText = this.configurationData?.ripsText;
      }
      this.$set(iconArr, 'packageConfig', this.configurationData.giftIconList);
      this.$set(iconArr.displayConfig, 'lotteryPlayType', this.configurationData.lotteryPlayType);
      this.$set(iconArr.displayConfig, 'headerText', headerText);
      this.$set(iconArr.displayConfig, 'ripsText', ripsText);
      this.$set(iconArr.displayConfig, 'lotteryNum', nums);
      const metaData = this.$refs.rewardBox.buildMetaData(iconArr, responseData);
      console.log(metaData);
      await this.$refs.rewardBox.showPop(metaData);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
